import React, { useState } from 'react';
import httpInjectorService from 'services/http-injector.service';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const WebLink = ({ onClose, onSave, work_id, work_type }) => {
  const [url, setUrl] = useState('');
  const [text, setText] = useState('');
  const project_id = useParams();
 

  const handleSubmit = async () => {
    let reqbody = {
      web_link: url,
      description: text,
      work_id: work_id,
      work_type: work_type,
      project_id: project_id.id || project_id.projectId,
    };
    try {
      let response = await httpInjectorService.addWebLink(reqbody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        onSave();
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      throw error;
    }
  };

  return (
    <div style={{ marginTop: '16px', width: '700px' }}>
      <h3 style={{ marginBottom: '12px' }}>Add Web Link</h3>

      {/* Row for inputs */}
  <div style={{ display: "flex", gap: "8px", maxWidth: "520px" }}>
  {/* URL */}
  <div style={{ flex: 1 }}>
    <label
      style={{
        display: "block",
        marginBottom: "3px",
        fontSize: "13px",
      }}
    >
      URL
    </label>
    <input
      style={{
        width: "100%",
        padding: "6px 8px", // 👈 slightly bigger
        fontSize: "13px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        outline: "none",
      }}
      placeholder="https://www.example.com"
      value={url}
      onChange={(e) => setUrl(e.target.value)}
      onFocus={(e) => {
        e.target.style.border = "1px solid #2684ff";
        e.target.style.boxShadow = "0 0 0 1px #2684ff";
      }}
      onBlur={(e) => {
        e.target.style.border = "1px solid #ccc";
        e.target.style.boxShadow = "none";
      }}
    />
  </div>

  {/* Link Text */}
  <div style={{ flex: 1 }}>
    <label
      style={{
        display: "block",
        marginBottom: "3px",
        fontSize: "13px",
      }}
    >
      Link text
    </label>
    <input
      style={{
        width: "100%",
        padding: "6px 8px", // 👈 slightly bigger
        fontSize: "13px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        outline: "none",
      }}
      placeholder="Add a description..."
      value={text}
      onChange={(e) => setText(e.target.value)}
      onFocus={(e) => {
        e.target.style.border = "1px solid #2684ff";
        e.target.style.boxShadow = "0 0 0 1px #2684ff";
      }}
      onBlur={(e) => {
        e.target.style.border = "1px solid #ccc";
        e.target.style.boxShadow = "none";
      }}
    />
  </div>
</div>

      {/* Buttons */}
    <div
  style={{
    display: "flex",
    justifyContent: "flex-start",
    gap: "8px",
    marginTop: "12px",
  }}
>
  <button
    onClick={onClose}
    style={{
      padding: "4px 10px",
      fontSize: "12px",
      border: "1px solid #ccc",
      background: "#f5f5f5",
      cursor: "pointer",
      borderRadius: "4px",
    }}
  >
    Cancel
  </button>

  <button
    onClick={handleSubmit}
    style={{
      padding: "4px 10px",
      fontSize: "12px",
      background: "#007bff",
      color: "#fff",
      border: "none",
      cursor: "pointer",
      borderRadius: "4px",
    }}
    onMouseOver={(e) => (e.target.style.background = "#0056b3")}
    onMouseOut={(e) => (e.target.style.background = "#007bff")}
  >
    Link
  </button>
</div>
    </div>
  );
};

export default WebLink;
